import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';
import FONTS from '@mlb/react-patterns/style/fonts.ts';

const ListItem = styled.li`
    color: ${COLORS.mlbGrey3};
    font-family: ${FONTS.primaryFont};
    font-size: 13px;
    font-weight: 600;
`;

const Strong = styled.strong`
    color: ${COLORS.mlbWhite};
    font-weight: 700;
`;

const Stat = ({
    label,
    stat,
}) => {

    return (
        <ListItem>
            {`${label}: `}
            <Strong>{stat || '-'}</Strong>
        </ListItem>
    );

};

Stat.propTypes = {
    label: PropTypes.string.isRequired,
    stat: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]),
};

Stat.defaultProps = {
    stat: undefined,
};

export default Stat;
